import React, {Children, useEffect, useState} from 'react'
import { Descriptions, Tabs, Card } from '@convertlab/cl-design'
import PropTypes from "prop-types";

const CodeBlock = ({ children }) => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(typeof window !== 'undefined');
  }, [])

  return isClient ?
      (<Descriptions column={1} colon={false} key="descriptions">
        <Descriptions.Item
            label="代码示例"
            className="ant-descriptions-item-block ant-descriptions-item-mark"
        >
          <Card>
            <Tabs type="card">
              {Children.toArray(children).map((child) => (
                  <Tabs.TabPane tab={child.props.language} key={child.props.language}>
                    {child}
                  </Tabs.TabPane>))}
            </Tabs>
          </Card>
        </Descriptions.Item>
      </Descriptions>
      ) : null;
}

CodeBlock.propTypes = {
  children: PropTypes.node.isRequired,
}

export default CodeBlock
